import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import useResponsive from '@/hooks/useResponsive';

export interface ConfirmationCardProps {
  step: number;
  title: string | React.ReactNode;
  description: string | React.ReactNode;
  goEdit: (step: number) => void;
}

const ConfirmationCard = (item: ConfirmationCardProps) => {
  const { step, title, description, goEdit } = item;
  const theme = useTheme();
  const isMobile = useResponsive('down', 'sm');
  const isSmallDrawer = useResponsive('between', 'lg', 'xl');
  return (
    <Paper
      elevation={3}
      sx={{
        display: 'flex',
        position: 'relative',
        flexDirection: { xxs: 'column', sm: 'row', lg: 'column', xl: 'row' },
        width: '100%',
        padding: `${theme.spacing(2)} `,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xxs: 'row-reverse', sm: 'column', lg: 'row-reverse', xl: 'column' },
          justifyContent: 'center',
          alignItems: 'center',
          minWidh: '50px',
          padding: theme.spacing(2),
          gap: { xxs: '0.5rem', sm: '0' },
        }}
      >
        <Typography variant="subtitle1" color={theme.palette.primary.main}>
          0{step}
        </Typography>
        <CheckCircleIcon color="primary" fontSize="large" />
      </Box>
      <Divider
        orientation={isMobile || isSmallDrawer ? 'horizontal' : 'vertical'}
        sx={{ margin: `0 ${theme.spacing(2)}` }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          padding: theme.spacing(2),
          width: '100%',
        }}
      >
        <Typography
          variant="body1"
          sx={{ width: { xxs: '100%', sm: '85%', lg: '100%', xl: '85%' } }}
        >
          {title}
        </Typography>
        {typeof description === 'string' ? (
          <Typography
            variant="body2"
            sx={{ width: { xxs: '100%', sm: '85%', lg: '100%', xl: '85%' } }}
          >
            {description}
          </Typography>
        ) : (
          description
        )}
      </Box>
      <IconButton
        onClick={() => goEdit(step)}
        sx={{ position: 'absolute', top: '0.25rem', right: '0.25rem' }}
      >
        <EditIcon />
      </IconButton>
    </Paper>
  );
};

export default ConfirmationCard;
